(() => {
  const init = root => {
    if (root.dataset.storyReady) return;
    root.dataset.storyReady = 'true';
    const content = root.querySelector('[data-story-content]');
    const nav = root.querySelector('[data-story-nav]');
    if (!content || !nav) return;
    const structure = content.querySelector(':scope > .alsaey-product-description') || content;
    const headings = [...content.querySelectorAll('h1,h2,h3,h4')].filter(h => h.textContent.trim());
    const directHeadings = headings.filter(h => h.parentElement === structure);
    if (directHeadings.length > 0) {
      let panel;
      [...structure.childNodes].forEach(node => {
        if (!panel && node.nodeType === 3 && !node.textContent.trim()) return;
        if (directHeadings.includes(node) || !panel) {
          panel = document.createElement('div');
          panel.className = 'sae-story__chapter';
          structure.insertBefore(panel, node);
        }
        panel.appendChild(node);
      });
      structure.classList.add('sae-story__content--chapters');
    }
    const targets = headings.slice(0, 8);
    if (targets.length > 1) {
      targets.forEach((heading, index) => {
        if (!heading.id) heading.id = root.id + '-chapter-' + index;
        const link = document.createElement('a');
        link.href = '#' + heading.id;
        const count = document.createElement('span');
        count.textContent = String(index + 1).padStart(2, '0');
        link.append(count, document.createTextNode(heading.textContent.trim()));
        nav.append(link);
      });
      nav.hidden = false;
      if ('IntersectionObserver' in window) {
        const spy = new IntersectionObserver(entries => {
          entries.forEach(entry => {
            if (!entry.isIntersecting) return;
            [...nav.children].forEach(link => {
              const active = link.hash === '#' + entry.target.id;
              if (active) link.setAttribute('aria-current', 'location');
              else link.removeAttribute('aria-current');
            });
          });
        }, { rootMargin: '-15% 0px -55% 0px' });
        targets.forEach(h => spy.observe(h));
      }
    }
    content.querySelectorAll('table').forEach(table => {
      const scroll = document.createElement('div');
      scroll.className = 'sae-story__table-scroll';
      scroll.tabIndex = 0;
      scroll.setAttribute('role', 'region');
      scroll.setAttribute('aria-label', table.querySelector('caption')?.textContent || root.getAttribute('aria-label'));
      table.before(scroll);
      scroll.append(table);
    });
    const dialog = root.querySelector('[data-story-lightbox]');
    const image = root.querySelector('[data-story-lightbox-image]');
    let trigger;
    if (dialog && image && typeof dialog.showModal === 'function') {
      root.querySelectorAll('[data-story-zoom]').forEach(link => link.addEventListener('click', event => {
        if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
        event.preventDefault();
        trigger = link;
        image.src = link.href;
        image.alt = link.querySelector('img')?.alt || '';
        dialog.showModal();
      }));
      dialog.addEventListener('click', event => { if (event.target === dialog) dialog.close(); });
      dialog.addEventListener('close', () => { image.removeAttribute('src'); trigger?.focus(); });
    }
  };
  document.querySelectorAll('[data-sae-story]').forEach(init);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-sae-story]').forEach(init));
})();
